document.addEventListener("alpine:init", function () {
    Alpine.data('admin_credits_management_b2b_index_x_data', function () {
        return {
            init() {
                try {
                    this.get_data();
                    this.get_clearbit_data();
                    this.render_chart();
                    this.render_clearbit_chart();
                    this.get_monthly_credits_consumed();
                    this.get_b2b_credits_per_show();
                } catch (error) {
                    console.error("Error initializing component:", error);
                }
            },
            b2b_index_data: {
                selected_date_range: '1M',
                loading_chart: true,
                chartkick_data: []
            },
            b2b_clearbit_index_data: {
                selected_date_range: '1M',
                loading_chart: true,
                chartkick_data: []
            },
            monthly_credits_consumed: {
                loading: true,
                data: []
            },
            credits_per_show: {
                loading: true,
                data: [],
                b2b_search_shows: ''
            },
            // Spread other objects with bound methods to maintain Alpine `this` context
            ...b2b_credit_usage_overtime,
            ...b2b_clearbit_credit_usage_overtime,
            ...monthly_credits_consumed_data,
            ...b2b_credits_per_show,
            convertToCSV(data) {
                if (!data || !data.length) {
                    return "";
                }

                // Check if data is an array of objects or an array of arrays
                const isArrayOfObjects = typeof data[0] === 'object' && !Array.isArray(data[0]);

                if (isArrayOfObjects) {
                    // Array of objects
                    const headers = Object.keys(data[0]);
                    const rows = data.map(row =>
                        headers.map(header => `"${row[header] || ''}"`).join(",")
                    );
                    return [headers.join(","), ...rows].join("\n");
                } else {
                    // Array of arrays
                    return data.map(row => row.map(item => `"${item}"`).join(",")).join("\n");
                }
            },
            downloadCSV(name, data) {
                const csvContent = this.convertToCSV(data);
                const blob = new Blob([csvContent], {type: "text/csv"});
                const url = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                a.download = `${name}.csv`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                URL.revokeObjectURL(url);
            }
        };
    });
});

// B2B Credit Usage Overtime
const b2b_credit_usage_overtime = {
    async select_date_range(range) {
        this.b2b_index_data.selected_date_range = range;
        await this.get_data();
    },

    async get_data() {
        const api_url = document.getElementById('qlj-credits-management')?.dataset?.apiUrl;

        if (!api_url) {
            console.error("API URL not found");
            return;
        }

        try {
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({
                    date_range: this.b2b_index_data.selected_date_range,
                    method: 'get_b2b_credit_usage_overtime'
                })
            });

            const data = await response.json();
            this.b2b_index_data.chartkick_data = data;
            this.render_chart();
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    },

    render_chart() {
        this.b2b_index_data.loading_chart = true;

        new Chartkick.AreaChart('line-chart', this.b2b_index_data.chartkick_data, {
            colors: ["#b00", "#666"],
            curve: false,
            xtitle: "Date Range",
            ytitle: "Credit usage overtime"
        });

        this.b2b_index_data.loading_chart = false;
    }
};

// B2B Clearbit Credit Usage Overtime
const b2b_clearbit_credit_usage_overtime = {
    async select_clearbit_date_range(range) {
        this.b2b_clearbit_index_data.selected_date_range = range;
        await this.get_clearbit_data();
    },

    async get_clearbit_data() {
        const api_url = document.getElementById('qlj-credits-management')?.dataset?.apiUrl;

        if (!api_url) {
            console.error("API URL not found");
            return;
        }

        try {
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({
                    date_range: this.b2b_clearbit_index_data.selected_date_range,
                    method: 'get_b2b_clearbit_credit_usage_overtime'
                })
            });

            const data = await response.json();
            this.b2b_clearbit_index_data.chartkick_data = data;
            this.render_clearbit_chart();
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    },

    render_clearbit_chart() {
        this.b2b_clearbit_index_data.loading_chart = true;

        new Chartkick.ColumnChart('clearbit-line-chart', this.b2b_clearbit_index_data.chartkick_data, {
            colors: ["#b00", "#666"],
            curve: false,
            xtitle: "Date Range",
            ytitle: "Credit usage overtime"
        });

        this.b2b_clearbit_index_data.loading_chart = false;
    }
};

// Monthly Credits Consumed Data
const monthly_credits_consumed_data = {
    async get_monthly_credits_consumed() {
        let that = this; // In case `this` is lost in the fetch context
        const api_url = document.getElementById('qlj-credits-management')?.dataset?.apiUrl;

        if (!api_url) {
            console.error("API URL not found");
            return;
        }

        try {
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({
                    method: 'get_monthly_credits_consumed'
                })
            });

            let monthly_data = await response.json();
            that.monthly_credits_consumed.data = monthly_data; // Store response in Alpine data
            that.monthly_credits_consumed.loading = false;
        } catch (error) {
            console.error("Error fetching monthly credits consumed data:", error);
        }
    }
};

const b2b_credits_per_show = {
    async get_b2b_credits_per_show() {
        let that = this; // In case `this` is lost in the fetch context
        const api_url = document.getElementById('qlj-credits-management')?.dataset?.apiUrl;

        if (!api_url) {
            console.error("API URL not found");
            return;
        }

        try {
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({
                    method: 'get_b2b_credits_per_show'
                })
            });

            let credits_per_show = await response.json();
            that.credits_per_show.data = credits_per_show;
            that.credits_per_show.loading = false;
        } catch (error) {
            console.error("Error fetching credits per show data:", error);
        }
    },

    filtered_shows() {
        return this.credits_per_show.data.filter((show) => {
            // Check if show[5] has null values or empty and skip them
            return show.show_title.toLowerCase().includes(this.credits_per_show.b2b_search_shows.toLowerCase());
        });
    },

    daily_budget_met_label(show) {
        if (show.blocked) {
            return 'Blocked';
        }

        if (!show.daily_counters_available) {
            return 'Unavailable';
        }

        return show.daily_budget_met ? 'Yes' : 'No';
    },

    remaining_daily_budget_label(show) {
        if (show.blocked) {
            return 'Blocked';
        }

        if (!show.daily_counters_available) {
            return 'Unavailable';
        }

        return show.remaining_daily_budget;
    }
}
